import numOfDaysInCurrentMonth from '../../lib/numOfDaysInCurrentMonth';

const numbers = [...Array(numOfDaysInCurrentMonth()).keys()].map((x) => x + 1);

// convert to correct format
const paydateOrdinals = numbers.map((x) => ({
  value: x.toString(),
  text:  x.toString(),
}));

export default paydateOrdinals;
